import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { getRegionFromHostname } from '@/modules/region/domain/hostname-resolver';
import { regionService } from '@/modules/region/domain/region.service';

export default function (context, inject) {
  const queryRegion = context.route?.query?.region;
  const { logger } = getLoggerService();

  let countryCode;

  if (queryRegion && regionService.isValidRegion(queryRegion)) {
    countryCode = regionService.getRegionCode(queryRegion);
  } else {
    if (queryRegion) {
      const hostname = process.client
        ? window.location.hostname
        : context.req.headers['x-original-host'] || context.req.headers.host;

      logger.warn('Invalid region detected', {
        region: queryRegion,
        hostname,
        path: context.route.path,
      });
    }

    const hostname = process.client
      ? window.location.hostname
      : context.req.headers['x-original-host'] || context.req.headers.host;

    countryCode = getRegionFromHostname(hostname);
  }

  logger.debug('Region detected', { region: countryCode });
  inject('countryCode', countryCode);

  if (process.server) {
    context.beforeNuxtRender(({ nuxtState }) => {
      nuxtState.host = context.req.headers.host;
      nuxtState.geo = {
        city: context.req.headers['cf-ipcity'],
        continent: context.req.headers['cf-ipcontinent'],
        ip: context.req.headers['cf-connecting-ip'],
        lat: context.req.headers['cf-iplatitude'],
        long: context.req.headers['cf-iplongitude'],
        postalCode: context.req.headers['cf-postal-code'],
        regionCode: context.req.headers['cf-region-code'],
        state: context.req.headers['cf-region'],
        timezone: context.req.headers['cf-timezone'],
        country: context.req.headers['cf-ipcountry'],
      };
    });
  } else {
    inject('host', context.nuxtState?.host);
    inject('geo', context.nuxtState?.geo);
    inject('isMississippi', context.nuxtState?.geo?.country === 'US' && context.nuxtState?.geo?.regionCode === 'MS');
  }
}
